// Radha — entry point. Mounts <App/> into #root.
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./theme.css";
// layers over theme.css when data-skin="zoho"; import order matters
import "./theme-zoho.css";
import { resolveSkin } from "./components/SkinToggle";

// apply a previously chosen theme before first paint (else follow the OS)
try {
  const saved = localStorage.getItem("radha.theme");
  if (saved === "dark" || saved === "light") document.documentElement.dataset.theme = saved;
} catch { /* private mode — fall back to OS preference */ }

// and the interface skin, likewise before paint so it never flashes
resolveSkin();

const el = document.getElementById("root");
if (!el) throw new Error("missing #root element");
createRoot(el).render(<App />);
